export default "__VITE_ASSET__BB$x1plF__"